import React, { useState, useEffect } from "react";
import { Table, Tooltip, Spin, Modal, Drawer } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import ErrorLogout from "../../../helpers/ErrorLogout";
import Pagination from "../Pagination";
import moment from "moment";
import UnAssignedSurveyList from "./UnAssignedSurveyList";
import { useNavigate } from "react-router-dom";
import { getSurveySettlements } from "../../../api/CommonRequest";
import PaymentTransfer from "./PaymentTransfer";

const SurveySettlement = ({ pages }) => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("assigned");

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loader, setLoader] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(5);
    const [limit, setLimit] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [change, setChange] = useState();
    const [surveySettlementData, setsurveySettlementData] = useState([]);
    const [singlePaymentData, setSinglePaymentData] = useState([]);
    const [activeTab1, setActiveTab1] = useState(""); // Update initial state to 'all'
    const [tabFilter1, setTabFilter1] = useState(""); // Update initial state to 'all'
    // ...
    // const tabs = ['All', 'Live', 'On Hold', 'Cancelled'];
    const tab1 = [
        { label: "All", value: "" },
        { label: "Pending", value: "pending" },
        { label: "Processing", value: "processing" },
        { label: "Completed", value: "completed" },
    ];


    // Fetch data from backend
    useEffect(() => {
        const surveySettlementsCall = async () => {
            try {
                setLoader(true);
                const { data } = await getSurveySettlements({
                    status: tabFilter1,
                    page: currentPage,
                    limit: limit,
                });
                // console.log("data", data);

                if (data?.success) {
                    setsurveySettlementData(data?.paymentTransactionList);
                    setTotalPages(data?.totalPages);
                    setCurrentPage(data?.currentPage);
                    setTotalItems(data?.totalItems);
                    // setUnassignedCount(data?.unassignedCount);

                    setLoader(false);
                }
            } catch (error) {
                setLoader(false);
                setsurveySettlementData([]);
                console.log(error);
                console.log(error.message);
                if (error?.response?.status === 401) {
                    ErrorLogout(error);
                }
            }
        };
        surveySettlementsCall();
        setSelectedRowKeys([]);
    }, [limit, currentPage, tabFilter1, change]);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };
    const handleLimit = (e) => {
        const selectedValue = parseInt(e.target.value); // Convert value to integer if needed
        setLimit(selectedValue); // Update state with the selected value
        setCurrentPage(1);
    };

    // Row selection config
    const rowSelection = {
        selectedRowKeys,
        onChange: (newSelectedRowKeys) => setSelectedRowKeys(newSelectedRowKeys),
    };

    const assignedColumns = [
        {
            title: "Tranction ID",
            dataIndex: "_id",
            key: "_id",
        },
        {
            title: "Type",
            dataIndex: "type",
            key: "type",
        },
        {
            title: "Amount",
            dataIndex: "amount",
            key: "amount",
        },
        { title: "Payment Mode", dataIndex: "paymentMode", key: "paymentMode" },

        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status) => (
                <div className="flex items-center gap-2">
                    <span
                        className={`py-1 rounded-full text-xs ${status === "pending"
                            ? "text-yellow-600"
                            : status === "processing"
                                ? "text-blue-600"
                                : status === "completed"
                                    ? "text-green-600"
                                    : "text-gray-600"
                            }`}
                    >
                        {status === "pending"
                            ? "Pending"
                            : status === "processing"
                                ? "Processing"
                                : status === "completed"
                                    ? "Completed"
                                    : status ? status.charAt(0).toUpperCase() + status.slice(1) : ""}
                    </span>
                </div>
            ),
        },

        {
            title: "Created Date",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (date) => moment(date).format("DD MMM YYYY"),
        },
        {
            title: "Action",
            key: "action",
            render: (_, record) => (
                <div className="flex items-center gap-2">
                    <Tooltip title="View Details">
                        <button
                            onClick={() => showDrawer(record)}
                            className="w-8 h-8 flex items-center justify-center bg-blue-50 text-[#1955EB] rounded-lg hover:bg-[#1955EB] hover:text-white transition-all shadow-sm border border-blue-100"
                        >
                            <EyeOutlined style={{ fontSize: 16 }} />
                        </button>
                    </Tooltip>
                    {(record.status === 'pending' && record.type === "commission") && (
                        <Tooltip title="Pay">
                            <button
                                onClick={() => handlePay(record)}
                                className="h-8 px-3 flex items-center justify-center bg-blue-50 text-[#1955EB] rounded-lg hover:bg-[#1955EB] hover:text-white transition-all shadow-sm border border-blue-100 text-sm font-medium"
                            >
                                Pay
                            </button>
                        </Tooltip>
                    )}
                </div>
            ),
        },
    ];


    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setSinglePaymentData({})
    };


    const handlePay = (details) => {
        // console.log(details);
        setSinglePaymentData(details)
        showModal()

    }

    const [open, setOpen] = useState(false);
    const showDrawer = (details) => {
        setOpen(true);
        setSinglePaymentData(details)

    };
    const onClose = () => {
        setOpen(false);
        setSinglePaymentData({})

    };

    if (loader) {
        return (
            <div className="flex justify-center items-center min-h-[400px]">
                <Spin size="large" tip="Loading Settlements..." />
            </div>
        );
    }

    return (
        <div className="flex-grow overflow-y-auto scrollbar-hide p-4 lg:p-6 md:p-5">
            <div className="max-w-7xl mx-auto">
                <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 mb-6 mt-2">
                    <div className="text-left w-full">
                        <h1 className="text-2xl font-bold text-gray-800">Settlements</h1>
                        <p className="text-sm text-gray-500 mt-1">Manage and track all survey-related financial transactions.</p>
                    </div>
                </div>

                <div className="w-full overflow-x-auto scrollbar-hide py-1 mb-6">
                    <div className="flex border border-[#9FACF0] p-1.5 gap-1.5 rounded-[12px] w-max bg-white">
                        {tab1.map((tab) => (
                            <button
                                key={tab.value}
                                className={`h-10 px-6 whitespace-nowrap rounded-lg text-sm transition-all duration-200
                                ${activeTab1 === tab.value
                                        ? "bg-[#1955EB] text-white font-semibold shadow-md translate-y-[-1px]"
                                        : "bg-transparent text-gray-600 hover:bg-gray-50 font-medium"
                                    }`}
                                onClick={() => {
                                    setActiveTab1(tab.value);
                                    setTabFilter1(tab.value);
                                    setCurrentPage(1);
                                }}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="pt-2">
                    <Table
                        columns={assignedColumns}
                        rowSelection={rowSelection}
                        dataSource={surveySettlementData}
                        pagination={false}
                        size="small"
                        className="custom-table-header w-full overflow-x-auto custom-pagination border border-gray-100 rounded-xl"
                        rowKey="_id"
                    />

                    <div className="mt-6">
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            limit={limit}
                            totalItem={totalItems}
                            onPageChange={handlePageChange}
                            handleLimit={handleLimit}
                        />
                    </div>
                </div>
            </div>

            <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null} closable={false} maskClosable={false}>
                <PaymentTransfer transferData={singlePaymentData} handleCancel={handleCancel} setChange={setChange} />
            </Modal>

            <Drawer title="Payment Details" onClose={onClose} open={open}>
                <h3 className="font-bold mb-3">Transfer Details</h3>
                <div className="space-y-2">
                    <div className="flex justify-between">
                        <span>Amount:</span>
                        <span>₹{singlePaymentData.amount}</span>
                    </div>
                    <div className="flex justify-between">
                        <span>Type:</span>
                        <span>{singlePaymentData.type}</span>
                    </div>
                    <div className="flex justify-between">
                        <span>Payment Through:</span>
                        <span>{singlePaymentData.paymentThrough}</span>
                    </div>
                    <div className="flex justify-between">
                        <span>Payment Mode:</span>
                        <span>{singlePaymentData.paymentMode}</span>
                    </div>
                    <div className="flex justify-between">
                        <span>Status:</span>
                        <span>{singlePaymentData.status}</span>
                    </div>
                    <div className="flex justify-between font-semibold">
                        <span>Total Amount:</span>
                        <span>₹{singlePaymentData.amount}</span>
                    </div>
                </div>
                {singlePaymentData?.type === "deposit" ?
                    <div className="mt-5">

                        <h3 className="font-bold mb-3">Credited From</h3>
                        <div>
                            <p>Name: {singlePaymentData?.from?.name}</p>
                            <p>Role: {singlePaymentData?.from?.role}</p>
                            <p>Phone : {singlePaymentData?.from?.phone}</p>
                        </div>
                    </div>
                    :
                    <div className="mt-5">

                        <h3 className="font-bold mb-3">Contact Details</h3>
                        <div>
                            <p>Name: {singlePaymentData?.to?.name}</p>
                            <p>Role: {singlePaymentData?.to?.role}</p>
                            <p>Phone : {singlePaymentData?.to?.phone}</p>
                        </div>
                    </div>

                }
                {(singlePaymentData?.bankDetailsID && singlePaymentData?.type !== "deposit") &&
                    <div className="mt-5">
                        <h3 className="font-bold mb-3">Account Details</h3>
                        <div>
                            <p>Bank: {singlePaymentData?.bankDetailsID?.bankName}</p>
                            <p>Branch: {singlePaymentData?.bankDetailsID?.branchName}</p>
                            <p>Account Holder: {singlePaymentData?.bankDetailsID?.accountHolderName}</p>
                            <p>Account Number: {singlePaymentData?.bankDetailsID?.accountNumber}</p>
                            <p>IFSC: {singlePaymentData?.bankDetailsID?.ifscCode}</p>
                        </div>
                    </div>
                    // :
                    // <div className="mt-5">
                    //     <h3 className="font-bold mb-3">Account Details</h3>
                    //     <div>
                    //         <p>Bank: {singlePaymentData?.to?.roleDetails?.bankDetailsIDs?.bankName}</p>
                    //         <p>Branch: {singlePaymentData?.to?.roleDetails?.bankDetailsIDs?.branchName}</p>
                    //         <p>Account Holder: {singlePaymentData?.to?.roleDetails?.bankDetailsIDs?.accountHolderName}</p>
                    //         <p>Account Number: {singlePaymentData?.to?.roleDetails?.bankDetailsIDs?.accountNumber}</p>
                    //         <p>IFSC: {singlePaymentData?.to?.roleDetails?.bankDetailsIDs[?.ifscCode}</p>
                    //     </div>
                    // </div>
                }
            </Drawer>
        </div>
    );
};

export default SurveySettlement;
